<script>
import Vue from "vue";
import VueApexCharts from "vue-apexcharts";

import Aforo from "../graficos/Aforo.vue";

Vue.use(VueApexCharts);
Vue.component("apexchart", VueApexCharts);

export default {
  components: { Aforo },
  props: {
    data: Array,
    aforos: {
      type: Object,
      required: false,
    },
    irAforos: Function,
  },
  data() {
    return {
      chartOptions: {
        legend: {
          show: true,
          position: "bottom",
        },
        chart: {
          width: 100,
          type: "donut",
        },
        dataLabels: {
          enabled: true,
        },
        labels: [],
        responsive: [
          {
            breakpoint: 430,
            options: {
              chart: {
                width: 100,
              },
              legend: {
                show: false,
              },
            },
          },
        ],
      },
    };
  },
  computed: {
    series() {
      return this.data?.map((item) => item.data[0]) ?? [];
    },
  },
  watch: {
    data: {
      immediate: true,
      handler(newVal) {
        const labels = newVal?.map((item) => item.label);

        this.chartOptions.labels = labels;
      },
    },
  },
};
</script>

<template>
  <div
    class="grid grid-cols-2 p-4 border-primary border-[1px] rounded-xl shadow-md bg-white"
  >
    <div class="flex flex-col gap-4">
      <h1 class="!text-xl !font-bold text-left">Aforos por tipo de examen</h1>
      <div id="charts-vb-types" class="mt-2 mx-auto">
        <slot name="ver"></slot>
        <apexchart
          class="mx-auto"
          v-if="series && series.length > 0"
          type="donut"
          height="250"
          :options="chartOptions"
          :series="series"
        />
      </div>
    </div>

    <div class="flex flex-col gap-4">
      <aforo :data="aforos" :irADespachosPendientes="irAforos">
        <template slot="ver">
          <button
            class="boton-ver"
            @click="
              irAforos({
                estado: true,
                text: 'Requiere Aforo',
                value: 'Si',
                filtro: 'aforo',
              })
            "
          >
            Ver
          </button>
        </template>
      </aforo>
    </div>
  </div>
</template>
